import React from "react";
import { IconButton, Tooltip, Box } from "@mui/material";
import ReplyIcon from "@mui/icons-material/Reply";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PushPinIcon from "@mui/icons-material/PushPin";
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import ShortcutIcon from '@mui/icons-material/Shortcut';
import { useNavigate } from "react-router-dom";
import { axiosClientSignIn } from "../../axios/api";
import { fetchMessages } from '../../slice/chatSlice.jsx'
import { useSelector, useDispatch } from "react-redux";

const HoverActions = ({ message, onReply, onOpenThread, onForward, currentUser }) => {
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleOpenThread = (messageId) => {
    if (onOpenThread) {
      onOpenThread(messageId);
    } else {
      navigate(`/chat/thread/${messageId}`);
    }
  };

  const deleteMessage = async (messageId) => {
    try {
      await axiosClientSignIn.delete(`/chat/messages/${messageId}`);
      if (currentUser && currentUser._id) {
        dispatch(fetchMessages({ senderId: user.id, receiverId: currentUser._id }));
      }
    } catch (error) {
      console.error("❌ Error deleting message:", error);
    }
  };

  const onAction = (action, message) => {
    switch (action) {
      case "reply":
        if (onReply) onReply(message);
        else handleOpenThread(message._id);
        break;
      case "thread":
        handleOpenThread(message._id);
        break;
      case "delete":
        deleteMessage(message._id);
        break;
      case "copy":
        navigator.clipboard.writeText(message.content);
        break;
      case "pin":
        console.log("Pinning:", message);
        break;
      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: '2px',
        backgroundColor: "#FFFFFF",
        border: '1px solid rgba(148,163,184,0.2)',
        borderRadius: "10px",
        padding: "2px",
        boxShadow: '0 8px 20px rgba(15,23,42,0.08)',
        zIndex: 10,
        transition: 'all 0.2s ease'
      }}
    >
      <Tooltip title={onReply ? "Reply" : "Thread Reply"}>
        <IconButton 
          size="small" 
          onClick={(e) => { 
            e.stopPropagation(); 
            e.preventDefault(); 
            onAction("reply", message); 
          }}
          sx={{ color: '#64748B', '&:hover': { color: '#60A5FA', background: 'rgba(96, 165, 250, 0.08)' }, '&:active': { transform: 'scale(0.95)' } }}
        >
          <ReplyIcon sx={{ fontSize: '18px' }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Open Thread">
        <IconButton 
          size="small" 
          onClick={() => onAction("thread", message)}
          sx={{ color: '#64748B', '&:hover': { color: '#60A5FA', background: 'rgba(96, 165, 250, 0.08)' }, '&:active': { transform: 'scale(0.95)' } }}
        >
          <ChatBubbleOutlineIcon sx={{ fontSize: '17px' }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Copy Content">
        <IconButton 
          size="small" 
          onClick={() => onAction("copy", message)}
          sx={{ color: '#64748B', '&:hover': { color: '#60A5FA', background: 'rgba(96, 165, 250, 0.08)' }, '&:active': { transform: 'scale(0.95)' } }}
        >
          <ContentCopyIcon sx={{ fontSize: '17px' }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Forward Message">
        <IconButton 
          size="small" 
          onClick={(e) => {
            console.log("🛠️ HoverActions: Forward button clicked!", message._id);
            e.stopPropagation();
            e.preventDefault();
            if (onForward) {
              console.log("🛠️ HoverActions: Calling onForward prop!");
              onForward(message);
            } else {
              console.log("❌ HoverActions: onForward prop is MISSING!");
            }
          }}
          sx={{ color: '#64748B', '&:hover': { color: '#6366F1', background: 'rgba(99, 102, 241, 0.08)' }, '&:active': { transform: 'scale(0.95)' } }}
        >
          <ShortcutIcon sx={{ fontSize: '18px' }} />
        </IconButton>
      </Tooltip>

      <Tooltip title="Delete">
        <IconButton 
          size="small" 
          onClick={() => onAction("delete", message)}
          sx={{ color: '#F43F5E', '&:hover': { background: 'rgba(244, 63, 94, 0.05)' }, '&:active': { transform: 'scale(0.95)' } }}
        >
          <DeleteIcon sx={{ fontSize: '18px' }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default HoverActions;

